import React from 'react';
import MandatoryLabel from '@/components/UI/MandatoryLabel/MandatoryLabel';
import styles from '../TableListEditable.module.scss';

interface MandatoryColumnTitleProps {
  title: string;
  mandatoryLabelMargin: number;
}

const MandatoryColumnTitle: React.FC<MandatoryColumnTitleProps> = ({ title, mandatoryLabelMargin }) => (
  <div className={styles.ColumnTitleWrapper}>
    <span className={styles.ColumnTitle}>{title}</span>
    <MandatoryLabel marginLeft={mandatoryLabelMargin} />
  </div>
);

export default MandatoryColumnTitle;
